import uuid from 'uuid/v4';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BarChart from '../common/Charts/BarChart';
import {
  processData,
  IMAGES,
  checkAsterickFormate,
  labelToolTips,
} from '../../util/QuickReportsUtils';
import { MODULE_SOCIAL_MEDIA_ACTIVITY } from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';
import { MRI_CONNECY_STUDY_STI, QR_SMA_DISABLED_STUDIES } from '../../actions/urlTypes';

const chartColor = [
  '#247BA0',
  '#F25F5C',
  '#FFE066',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

export default class SocialMediaActivityProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRadioButton: 'Percent',
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
    };
  }

  componentDidMount() {
    const socialMediaUsers = this.props.data.socialMediaUsers[0];
    this.props.handletitle(
      'Social Media Activity Profile',
      `${socialMediaUsers.value.pct} of ${this.props.subTitleLabel} are ${socialMediaUsers.label}`
    );
    this.props.handleExportParams(
      this.state.selectedRadioButton,
      undefined,
      undefined
    );
    this.props.trackerFn({ subModule: MODULE_SOCIAL_MEDIA_ACTIVITY });
  }

  UNSAFE_componentWillReceiveProps() {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
  }

  comparerItem = (item1, item2) => {
    const val1 = item1.value.pct.replace('%', '');
    const val2 = item2.value.pct.replace('%', '');
    if (Number(val1) > Number(val2)) {
      return -1;
    }
    if (Number(val1) < Number(val2)) {
      return 1;
    }
    return 0;
  };

  filterValue = item => {
    if (this.state.selectedRadioButton === 'Percent') {
      if (item.value.sample < 31) {
        return `**${Math.round(Number(item.value.pct.replace(/%/g, '')))}%`;
      }
      if (item.value.sample < 61) {
        return `*${Math.round(Number(item.value.pct.replace(/%/g, '')))}%`;
      }
      return `${Math.round(Number(item.value.pct.replace(/%/g, '')))}%`;
    }
    if (item.value.sample < 31) {
      return `**${item.value.index}`;
    }
    if (item.value.sample < 61) {
      return `*${item.value.index}`;
    }
    return item.value.index;
  };

  checkAsterikLabel = (data, sample) => {
    if (sample < 31) {
      return `**${data}`;
    }
    if (sample < 61) {
      return `*${data}`;
    }
    return data;
  };

  handleRadioButtonChange = e =>
    this.setState({ selectedRadioButton: e.currentTarget.value }, () => {
      this.props.handleExportParams(
        this.state.selectedRadioButton,
        undefined,
        undefined
      );
    });

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  renderHowOftenVisit = () => {
    return (
      <BarChart
        chartTitle="SOCIAL MEDIA WEBSITE VISITS‡"
        chartColor={chartColor}
        barChartHeight={280}
        data={{
          processedData: processData(
            {
              rawData: this.props.data['How Often Visit'],
              y: this.state.selectedRadioButton === 'Percent' ? 'pct' : 'index',
            },
            this.updateAsteriskStatus,
            this.props.study
          ),
          tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
        }}
        dataLabels
        dataLabelFormat={
          this.state.selectedRadioButton === 'Percent'
            ? checkAsterickFormate(
                '{y}%',
                this.state.showDoubleAsterisk,
                this.state.showSingleAsterisk
              )
            : checkAsterickFormate(
                '{y}',
                this.state.showDoubleAsterisk,
                this.state.showSingleAsterisk
              )
        }
      />
    );
  };

  is30DaysData = () =>
    this.props.study &&
    /connect/gi.test(this.props.study.sd) &&
     MRI_CONNECY_STUDY_STI.indexOf(this.props.study.sti) !== -1 &&
    !QR_SMA_DISABLED_STUDIES.indexOf(this.props.study.st) !== -1;

  getRowData = () => {
    let value = [];
    if (this.is30DaysData()) {
      if (
        this.state.selectedRadioButton === 'Percent' &&
        this.props.data['socialMediaWebsites - last 30 days:pct']
      ) {
        value = this.props.data['socialMediaWebsites - last 30 days:pct'];
      } else if (this.props.data['socialMediaWebsites - last 30 days:index']) {
        value = this.props.data['socialMediaWebsites - last 30 days:index'];
      }
      return value;
    }
    if (
      this.state.selectedRadioButton === 'Percent' &&
      this.props.data['socialMediaWebsites - last 7 days:pct']
    ) {
      value = this.props.data['socialMediaWebsites - last 7 days:pct'];
    } else if (this.props.data['socialMediaWebsites - last 7 days:index']) {
      value = this.props.data['socialMediaWebsites - last 7 days:index'];
    }
    return value;
  };

  renderSocialMediaStatements = () => {
    const data =
      this.state.selectedRadioButton === 'Percent'
        ? this.props.data['socialMediaRank - any agree:pct']
        : this.props.data['socialMediaRank - any agree:index'];
    return data.map((item, index) => (
      <div key={index} className="row expanded border-bottom-1">
        <div
          className="large-2 columns"
          title={labelToolTips(
            item.label,
            item.value.sample,
            item.value.weighted,
            item.value.pct,
            item.value.index,
            this.state.showSingleAsterisk,
            this.state.showDoubleAsterisk
          )}
        >
          <h2 className="margin-top-20 label-text">{this.filterValue(item)}</h2>
        </div>
        <div className="large-10 columns">
          <p
            data-tooltip
            aria-haspopup="true"
            className=""
            title={labelToolTips(
              item.label,
              item.value.sample,
              item.value.weighted,
              item.value.pct,
              item.value.index,
              this.state.showSingleAsterisk,
              this.state.showDoubleAsterisk
            )}
          >
            {item.label}
          </p>
        </div>
      </div>
    ));
  };

  renderSocialMediaConsumption = () =>
    this.props.data['Social Media Consumption'].map(item => (
      <tr key={uuid()}>
        <td>{item.label}</td>
      </tr>
    ));

  render() {
    return (
      <div>
        <div className="row expanded quick-report-graph-wrapper border-0">
          <div className="quick-report-radio display-center">
            <p>
              <input
                type="radio"
                id="percentType"
                name="ChartType"
                value="Percent"
                checked={this.state.selectedRadioButton === 'Percent'}
                onChange={this.handleRadioButtonChange}
              />
              <label htmlFor="percentType">
                <span>Percent</span>
              </label>
            </p>
            <p>
              <input
                type="radio"
                id="indexType"
                name="ChartType"
                value="Index"
                checked={this.state.selectedRadioButton === 'Index'}
                onChange={this.handleRadioButtonChange}
              />
              <label htmlFor="indexType">
                <span>Index</span>
              </label>
            </p>
          </div>
          <div className="column large-12">
            <div className="column large-6 padding-0">
              <div className="quick-report-cards min-height-280">
                <div className="row expanded">
                  <div className="small-3 columns padding-0">
                    <h4
                      className="report-chart-title"
                      title="Social Media Statements"
                    >
                      Social Media Statements:
                      <span className="text-red">Any Agree</span>
                    </h4>

                    <img
                      className="img-responsive network-image"
                      src={IMAGES.ICON_social}
                      alt="social"
                    />
                  </div>
                  <div className="small-9 columns padding-0">
                    {this.renderSocialMediaStatements()}
                  </div>
                </div>
              </div>
            </div>
            <div className="column large-6 padding-0">
              <div className="quick-report-cards margin-right-0">
                {this.renderHowOftenVisit()}
              </div>
            </div>
          </div>
          <div className="large-12 columns">
            <div className="column large-5 padding-0">
              <div className="quick-report-cards">
                <BarChart
                  chartTitle={`${
                    this.is30DaysData()
                      ? 'SOCIAL MEDIA WEBSITES: LAST 30 DAYS OF TOP 5 WEBSITES'
                      : 'SOCIAL MEDIA WEBSITES: LAST 7 DAYS OF TOP 5 WEBSITES'
                  }`}
                  chartColor={chartColor}
                  yAxisLabel={false}
                  marginLeft="150"
                  barChartHeight={230}
                  dataLabelFormat={
                    this.state.selectedRadioButton === 'Percent'
                      ? checkAsterickFormate(
                          '{y}%',
                          this.state.showDoubleAsterisk,
                          this.state.showSingleAsterisk
                        )
                      : checkAsterickFormate(
                          '{y}',
                          this.state.showDoubleAsterisk,
                          this.state.showSingleAsterisk
                        )
                  }
                  data={{
                    processedData: processData(
                      {
                        rawData: this.getRowData(),
                        y:
                          this.state.selectedRadioButton === 'Percent'
                            ? 'pct'
                            : 'index',
                      },
                      this.updateAsteriskStatus,
                      this.props.study
                    ),
                    tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                  }}
                  chartType="bar"
                  dataLabels
                />
              </div>
            </div>
            <div className="column large-7 padding-0">
              <div className="quick-report-cards margin-right-0">
                <h4
                  className="report-chart-title"
                  title="Social Media Consumption by Device (Last 7 Days)"
                >
                  Social Media Consumption by Device (Last 7 Days)
                </h4>
                <div className="large-12 column">
                  {this.props.data['Social Media Consumption']
                    .sort((item1, item2) => this.comparerItem(item1, item2))
                    .map(item => (
                      <div key={uuid()} className="width-14 column text-center">
                        <div
                          className="social-media-profile-icon"
                          title={labelToolTips(
                            item.label,
                            item.value.sample,
                            item.value.weighted,
                            item.value.pct,
                            item.value.index,
                            this.state.showSingleAsterisk,
                            this.state.showDoubleAsterisk
                          )}
                        >
                          <img
                            src={IMAGES[item.value.icon.replace(/-/g, '_')]}
                            alt=""
                          />
                        </div>
                        <div className="social-media-profile-icon-label">
                          <div
                            className="label-item"
                            title={labelToolTips(
                              item.label,
                              item.value.sample,
                              item.value.weighted,
                              item.value.pct,
                              item.value.index,
                              this.state.showSingleAsterisk,
                              this.state.showDoubleAsterisk
                            )}
                          >
                            {item.label}
                          </div>
                          <div
                            className="label-text"
                            title={labelToolTips(
                              item.label,
                              item.value.sample,
                              item.value.weighted,
                              item.value.pct,
                              item.value.index,
                              this.state.showSingleAsterisk,
                              this.state.showDoubleAsterisk
                            )}
                          >
                            {this.checkAsterikLabel(
                              item.value[
                                this.state.selectedRadioButton === 'Percent'
                                  ? 'pct'
                                  : 'index'
                              ],
                              item.value.sample
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <QuickReportFootNote
            studyInfo={this.props.study}
            className="padding-astrick font-12"
            showSingleAsterisk={this.state.showSingleAsterisk}
            showDoubleAsterisk={this.state.showDoubleAsterisk}
          />
        </div>
      </div>
    );
  }
}

SocialMediaActivityProfile.propTypes = {
  subTitleLabel: PropTypes.string,
  data: PropTypes.shape({
    socialMediaUsers: PropTypes.arrayOf(PropTypes.shape({})),
    'Social Media Consumption': PropTypes.arrayOf(PropTypes.shape({})),
    'How Often Visit': PropTypes.arrayOf(PropTypes.shape({})),
    'socialMediaWebsites - last 7 days:pct': PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    'socialMediaWebsites - last 7 days:index': PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    'socialMediaRank - any agree:pct': PropTypes.arrayOf(PropTypes.shape({})),
    'socialMediaRank - any agree:index': PropTypes.arrayOf(PropTypes.shape({})),
  }),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  trackerFn: PropTypes.func,
  study: PropTypes.shape({
    st: PropTypes.string,
    sti: PropTypes.string,
    sd: PropTypes.string,
  }),
};
